import React, { Component } from "react";
import Modal from "../utils/modal";
// import * as emailjs from 'emailjs-com'
import "./warnme.css";
import axios from "axios";
import emailjs from "emailjs-com";
export default class Warnme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalAction: "",
      formName: "",
      formEmail: "",
      formCelular: "",
      formPhone: "",
    };
  }

  /**
   *  Validação do telefone
   */
  onChangeInputValue = (e) => {
    const inputInfo = e.target.name;
    this.setState({ inputInfo: e.target.name });
    let value = e.target.value;
    value = this.clearWhiteSpace(value);

    if (inputInfo === "formCelular") {
      value = this.onChangePhone(e);
    }
    this.setState({
      [inputInfo]: value,
    });
  };

  clearWhiteSpace = (value) => {
    if (value == null) return value;
    return value.replace(/^\s+/g, "");
  };

  onChangePhone = (e) => {
    let value;
    value = e.target.value.replace(/\D/g, "");

    if (value.length === 10) {
      const str = `00000000${value}`;
      value = str
        .substr(-10)
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3");
      return value;
    }

    if (value.length >= 11) {
      const str = `00000000${value}`;
      value = str
        .substr(-11)
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3");
      return value;
    }
    return value;
  };

  validatePhone = () => {
    const number =
      this.state.formCelular === undefined ? "" : this.state.formCelular;
    if (number.length <= 9) {
      return true;
    }

    return false;
  };

  /**
   * 'Submit' do formulário
   */
  submitFormAvise = (e) => {
    e.preventDefault();
    const validatePhone = this.validatePhone();

    if (validatePhone) {
      const modalAction = "tel";
      const modal = true;

      return this.setState({ modal, modalAction });
    }

    const { formName, formEmail, formPhone, formCelular } = this.state;
    const formContent = {
      to_name: "Hit-Bra",
      from_name: formName,
      reply_to: formEmail,
      phone_number: formPhone,
      phone_celular: formCelular,
      form_tipo: "AVISE-ME: HIT-BRA",
      curso: this.props.description,
    };
    console.log(this.props.description);
    const keys = [
      "B7F8908A957E3D6618245C667DF1B0E010C72FDC7478737E756DB0E8D178FA2E",
      "YWxlbcOjbyBmb2kgYSBlc29sYSBhcHJlbmRlciBhIGVzdHVkYXI=",
      "s(n[)[y=},q6DxCs5c54seGbbpKAfb>zpNt",
      "2DB2B674BF72654C33959F71E2A1465792A85DC776945C08A7B1912BBF45AA27",
      "anVhcmV6IG1hdGhldXMgd2lsbGlhbSByZW7Dqg==",
      ";;SNW!(7=RYDU6V^FNCCmq#5vFmqD;t8naSqX!9",
      "2CF24DBA5FB0A30E26E83B2AC5B9E29E1B161E5C1FA7425E73043362938B9824",
      "Ymx1bWVuYXUgY2FybGlzdG9zIHRldGV1IGNhcmxvcyBlZHVhcmRv",
      "_Y!NGjdq-Qg^UnyDr2~,'PSay64t;KhX[q&9*>",
      "579472CCD02915E5F56714328CAF2AD728848A4E4B4D43B471E9CA0BDD47E2AC",
      "Y2Ficml0byBuYSBzZXh0YSBmb2kgcGVzY2FyIG5hIGZhemVuZGluaGE=",
      "3=&HsW.F![XQm6Tr_f]bc>q}N(r)3Y`K>A:nx8t+",
      "7F5244143287B47563DEF1EBD45CE1C7C5D529F122ED6D5F9B77D8928F4DAE6C",
      "NDY1NDY0NDY1NDY1NjU0NTY2NTY0NTQ0NjU0NjQ2NjU5Nzg5Nzg=",
      "X#Tpsg>6W`(XH:94f#5XY?=&6#}^`t9k5ww-8b`",
    ];
    const random = Math.floor(Math.random() * keys.length);
    const config = {
      headers: {
        "Content-Type": "application/json",
        key: keys[random],
      },
    };

    axios.post("http://0.0.0.0:50001/prod", formContent, config).then(
      (response) => {
        var result = response.data;
        this.clearForm();
        this.onSuccessFormSubmit();
        console.log(result);
        console.log(process.env);
      },
      (error) => {
        this.onFailFormRequest();
        console.log(error);
        console.log(process.env);
      }
    );
  };

  // emailjs.send('<YOUR SERVICE ID>','<YOUR TEMPLATE ID>', '<YOUR PARAMS>', '<YOUR USER ID>')
  //     emailjs.send('smtp_server', 'template_curso', formContent, 'user_ydkNKT0G5WeDWqPZT6MkW')
  //       .then((response) => {
  //         this.clearForm()
  //         this.onSuccessFormSubmit()
  //       }, (error) => {
  //         this.onFailFormRequest()
  //       })
  // }

  submitFormDuvida = (e) => {
    e.preventDefault();

    const { formName, formEmail, formMsg } = this.state;
    const formContent = {
      to_name: "Hit-Bra",
      from_name: formName,
      reply_to: formEmail,
      form_tipo: "DÚVIDA: HIT-BRA",
      message_html: formMsg,
      curso: this.props.description,
    };

    console.log(this.state);
    const keys = [
      "B7F8908A957E3D6618245C667DF1B0E010C72FDC7478737E756DB0E8D178FA2E",
      "YWxlbcOjbyBmb2kgYSBlc29sYSBhcHJlbmRlciBhIGVzdHVkYXI=",
      "s(n[)[y=},q6DxCs5c54seGbbpKAfb>zpNt",
      "2DB2B674BF72654C33959F71E2A1465792A85DC776945C08A7B1912BBF45AA27",
      "anVhcmV6IG1hdGhldXMgd2lsbGlhbSByZW7Dqg==",
      ";;SNW!(7=RYDU6V^FNCCmq#5vFmqD;t8naSqX!9",
      "2CF24DBA5FB0A30E26E83B2AC5B9E29E1B161E5C1FA7425E73043362938B9824",
      "Ymx1bWVuYXUgY2FybGlzdG9zIHRldGV1IGNhcmxvcyBlZHVhcmRv",
      "_Y!NGjdq-Qg^UnyDr2~,'PSay64t;KhX[q&9*>",
      "579472CCD02915E5F56714328CAF2AD728848A4E4B4D43B471E9CA0BDD47E2AC",
      "Y2Ficml0byBuYSBzZXh0YSBmb2kgcGVzY2FyIG5hIGZhemVuZGluaGE=",
      "3=&HsW.F![XQm6Tr_f]bc>q}N(r)3Y`K>A:nx8t+",
      "7F5244143287B47563DEF1EBD45CE1C7C5D529F122ED6D5F9B77D8928F4DAE6C",
      "NDY1NDY0NDY1NDY1NjU0NTY2NTY0NTQ0NjU0NjQ2NjU5Nzg5Nzg=",
      "X#Tpsg>6W`(XH:94f#5XY?=&6#}^`t9k5ww-8b`",
    ];
    const random = Math.floor(Math.random() * keys.length);

    const config = {
      headers: {
        "Content-Type": "application/json",
        key: keys[random],
      },
    };

    axios.post("http://107.180.9.111:50001/prod", formContent, config).then(
      (response) => {
        var result = response.data;
        this.clearForm();
        this.onSuccessFormSubmit();
        console.log(result);
        console.log(process.env);
      },
      (error) => {
        this.onFailFormRequest();
        console.log(error);
        console.log(process.env);
      }
    );

    // emailjs.send('<YOUR SERVICE ID>','<YOUR TEMPLATE ID>', '<YOUR PARAMS>', '<YOUR USER ID>')
    // emailjs.send('smtp_server', 'template_curso', formContent, 'user_ydkNKT0G5WeDWqPZT6MkW')
    //   .then((response) => {
    //     this.clearForm()
    //     this.onSuccessFormSubmit()
    //   }, (error) => {
    //     this.onFailFormRequest()
    //   })
  };

  sendEmailWarnme = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "sendMessage",
        "template_bw173ld",
        e.target,
        "user_cz6Le3va9WTxaNDEplsbp"
      )
      .then(
        (result) => {
          alert("Contato enviado com sucesso!");
        },
        (error) => {
          alert(error.text);
        }
      );
    e.target.reset();
  };

  sendEmailDuvida = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_xhjpt98",
        "template_yimr7yh",
        e.target,
        "xRLFDoBXjN5a8bc_-"
      )
      .then(
        (result) => {
          console.log(result);
          alert("Contato enviado com sucesso!");
        },
        (error) => {
          alert(error.text);
        }
      );
    e.target.reset();
  };

  onSuccessFormSubmit = () => {
    const modalAction = "success";
    const modal = true;

    this.setState({ modal, modalAction });
  };

  onFailFormRequest = () => {
    const modalAction = "fail";
    const modal = true;

    this.setState({ modal, modalAction });
  };

  openModal = () => {
    const name = this.state.modalAction;
    let toRender;

    switch (name) {
      case "success":
        toRender = (
          <Modal closeModal={this.closeModal} customClass="success alignC">
            <h2>Mensagem enviada com sucesso!</h2>
            <div className="alignC">
              <a className="button success" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      case "fail":
        toRender = (
          <Modal closeModal={this.closeModal} customClass="fail">
            <h2>
              Não foi possível enviar sua mensagem, por favor, tente novamente.
            </h2>
            <div className="alignC">
              <a className="button warning" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      case "tel":
        toRender = (
          <Modal closeModal={this.closeModal}>
            <h2>Favor, preencher corretamente o de número telefone.</h2>
            <div className="alignC">
              <a className="button warning" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      default:
        this.setState({ modal: false });
    }

    return toRender;
  };

  closeModal = () => {
    this.setState({
      modal: false,
    });
  };

  clearForm = () => {
    document.getElementById("warnme").reset();
    this.setState({
      formName: "",
      formEmail: "",
      formPhone: "",
      formCelular: "",
      formMsg: "",
    });
  };
  render() {
    const nomeCurso = this.props.description;
    console.log(this.props.description);
    return (
      <div className="c-warnme">
        {this.state.modal ? this.openModal() : null}
        {this.props.disponibility === "Sim" ? (
          <React.Fragment>
            <h1 className="warnme-title">FICOU ALGUMA DÚVIDA?</h1>
            <p className="warnme-paragraph">Entre em contato conosco</p>
            {/* form ficou alguma dúvida*/}
            <form
              id="warnme"
              className="warnme-form"
              method="post"
              onSubmit={this.sendEmailDuvida}
              autoComplete="off"
              action=""
            >
              <div className="input-row">
                <div className="input-column">
                  <label for="warnmeName" className="warnme-label">
                    NOME
                  </label>
                  <input
                    id="warnmeName"
                    name="name"
                    // value={this.state.formName}
                    className="warnme-input"
                    type="text"
                    required
                    // onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
                <div className="input-column">
                  <label for="warnmeEmail" className="warnme-label">
                    E-MAIL
                  </label>
                  <input
                    id="warnmeEmail"
                    name="email"
                    className="warnme-input"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    required
                    onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
              </div>
              <div className="input-row">
                <div className="input-column-txt-area">
                  <label for="warnmeMsg" className="warnme-label">
                    MENSAGEM
                  </label>
                  <textarea
                    id="warnmeMsg"
                    name="message"
                    className="warnme-input txtArea"
                    maxLength="500"
                    onChange={(e) => this.onChangeInputValue(e)}
                  ></textarea>
                </div>
              </div>
              <div className="button-row">
                <button className="warnme-button" type="submit">
                  ENVIAR
                </button>
              </div>
            </form>
          </React.Fragment>
        ) : (
          //
          <React.Fragment>
            <h1 className="warnme-title">AVISE-ME</h1>
            <p className="warnme-paragraph">
              Gostaria de ser informado sobre novas turmas?
            </p>

            {/* form avise-me*/}
            <form
              id="warnme"
              className="warnme-form"
              method="post"
              onSubmit={this.sendEmailWarnme}
              autoComplete="off"
              action=""
            >
              <div className="input-row">
                <div className="input-column">
                  <label for="warnmeName" className="warnme-label">
                    NOME
                  </label>
                  <input
                    id="warnmeName"
                    name="name"
                    // value={this.state.formName}
                    className="warnme-input"
                    type="text"
                    required
                    // onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
                <div className="input-column">
                  <label for="warnmeEmail" className="warnme-label">
                    E-MAIL
                  </label>
                  <input
                    id="warnmeEmail"
                    name="email"
                    className="warnme-input"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    required
                    onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
              </div>

              <div className="input-row">
                <div className="input-column">
                  <label for="warnmeCelular" className="warnme-label">
                    CELULAR
                  </label>
                  <input
                    id="warnmeCelular"
                    name="cel"
                    // value={this.state.formCelular}
                    className="warnme-input"
                    type="cel"
                    required
                    // onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
                <div className="input-column">
                  <label for="warnmePhone" className="warnme-label">
                    TELEFONE
                  </label>
                  <input
                    id="warnmePhone"
                    name="tel"
                    className="warnme-input"
                    type="tel"
                    // value={this.state.formPhone}
                    // onChange={(e) => this.onChangeInputValue(e)}
                  />
                </div>
              </div>
              <div style={{zIndex:"-999999"}}>
                <input type="text" name="curso" value={this.props.description}/>
              </div>
              <div className="button-row">
                <button
                  className="warnme-button"
                  id="warnme-btnSend"
                  type="submit"
                >
                  ENVIAR
                </button>
                <input
                  type="text"
                  name="text"
                  value={this.props.description}
                  className="inputDescripSend"
                />
              </div>
            </form>
          </React.Fragment>
        )}
      </div>
    );
  }
}
//usar email e senha da hit-bra (avise-me e black) e deborahitbra (duvidas) para acessar emailjs



// WEBPACK FOOTER //
// ./src/components/workshop/warnme.js